import { render, staticRenderFns } from "./VariableTree.vue?vue&type=template&id=54f2e492"
import script from "./VariableTree.vue?vue&type=script&lang=js"
export * from "./VariableTree.vue?vue&type=script&lang=js"
import style0 from "./VariableTree.vue?vue&type=style&index=0&id=54f2e492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports